import instance from "../../helpers/AxiosInterceptor";

const BASE_URL = "/reports/vehicle-excel";

export const downloadVehicleTemplate = () =>
  instance.get(`${BASE_URL}/template`, { responseType: "blob" });

export const previewVehicleImport = (file) => {
  const data = new FormData();
  data.append("file", file);
  return instance.post(`${BASE_URL}/preview`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const importVehicles = (file) => {
  const data = new FormData();
  data.append("file", file);
  return instance.post(`${BASE_URL}/import`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const exportVehicles = (filters) =>
  instance.get(`${BASE_URL}/export`, {
    params: filters,
    responseType: "blob",
  });

export const loadVehicleImportHistory = () =>
  instance.get(`${BASE_URL}/history`);
